var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 34,
    viewBox: "0 0 51 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7505 6.51826C39.1144 -4.38451 29.1176 3.20068 29.1176 3.20068C28.4692 3.69068 27.2737 4.09355 26.4614 4.09542L23.7838 4.0973C22.9715 4.09823 21.776 3.69536 21.1286 3.20536C21.1286 3.20536 11.1308 -4.3817 4.49381 6.52107C-2.14136 17.4201 0.53257 29.2898 0.53257 29.2898C1.00102 32.196 2.54504 34.1354 5.45882 33.8918C8.36417 33.6492 14.6705 26.0649 14.6705 26.0649C15.1914 25.44 16.2829 24.9294 17.0933 24.9294L33.1463 24.9266C33.9576 24.9266 35.0482 25.4372 35.5682 26.0621C35.5682 26.0621 41.8754 33.6464 44.7854 33.889C47.6955 34.1326 49.2432 32.1914 49.7089 29.2869C49.7089 29.2869 52.3866 17.4192 45.7505 6.51826ZM19.0889 15.3926H15.6467V18.7102C15.6467 18.7102 14.9178 19.2667 13.7898 19.2527C12.6636 19.2358 12.1539 18.6456 12.1539 18.6456V15.3936H8.90289C8.90289 15.3936 8.49721 14.9776 8.38853 13.8823C8.28172 12.7871 8.8373 11.9017 8.8373 11.9017H12.2804V8.45953C12.2804 8.45953 12.9887 8.08008 14.0071 8.10913C15.0265 8.14098 15.7732 8.52418 15.7732 8.52418L15.7592 11.9008H19.0102C19.0102 11.9008 19.578 12.6297 19.6248 13.5104C19.6717 14.392 19.0889 15.3926 19.0889 15.3926ZM34.8777 19.174C33.3702 19.174 32.155 17.9551 32.155 16.4495C32.155 14.941 33.3702 13.7249 34.8777 13.7249C36.3786 13.7249 37.6031 14.941 37.6031 16.4495C37.6031 17.956 36.3786 19.174 34.8777 19.174ZM34.8777 11.6778C33.3702 11.6778 32.155 10.4598 32.155 8.95422C32.155 7.4458 33.3702 6.22969 34.8777 6.22969C36.3786 6.22969 37.6031 7.4458 37.6031 8.95422C37.6031 10.4608 36.3786 11.6778 34.8777 11.6778ZM41.6627 15.7018C40.1553 15.7018 38.9401 14.4838 38.9401 12.9773C38.9401 11.4698 40.1553 10.2528 41.6627 10.2528C43.1637 10.2528 44.3882 11.4698 44.3882 12.9773C44.3882 14.4838 43.1637 15.7018 41.6627 15.7018Z",
    fill: "url(#paint0_linear_876_16445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_876_16445",
    x1: 25.1213,
    y1: 0.632812,
    x2: 25.1213,
    y2: 33.9124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4398FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.a8cc8b86ef694cb6aed30444e71a8e22.svg";
export { ForwardRef as ReactComponent };